import ApiService from '@api/api-service';

let VCA = VCA || {};

VCA.ActivateAccountSetUp = (function ($) {
    let ui = {};
    let haveOneNumValid = false;
    let haveOneUppercaseValid = false;
    let haveOneLowercaseValid = false;
    let haveOneSpecialCharValid = false;
    let have8MinCharValid = false;
    let generalPwFinalValue = '';
    let confirmPwFinalValue = '';

    function cacheUI() {
        //Sections
        ui.$sections = $('section.js-account-step');
        ui.$FindYourHospitalStep = $('section[data-step="find-your-hospital"]');
        ui.$ProfileStep = $('section[data-step="profile"]');
        ui.$VerifyYourAccountStep = $('section[data-step="verify-your-account"]');
        ui.$SetPasswordStep = $('section[data-step="set-password"]');

        //Step1 - Find Your Hospital
        ui.$Step1ContinueBtn = $('#ActivateAcctFAHContinueBtn');
        ui.$Step1ZipCode = $('#ActivateAccountZipCode');
        ui.$Step1AcctFahContainer = $('.account-fah');
        ui.$Step1AcctFahList = $('.account-fah__list');
        ui.$Step1AcctFahErrMsg = $('.acct-fah-errormsg');
        ui.$Step1AcctFahSelectHospitalErrMsg = $('.acct-fah-errormsg.select-hospital');
        ui.$Step1AcctFahInvalidZipCodeErrMsg = $('.acct-fah-errormsg.invalid-zipcode');
        ui.$Step1AcctFahAPIErrMsg = $('.acct-fah-errormsg.api-error-msg');
        ui.$Step1AcctFahEmptyResponse = $('.acct-fah-errormsg.empty-response');
        ui.$Step1Radius = accountFAHRadius;
        ui.$Step1Geocoder;
        ui.$Step1CurrentLat;
        ui.$Step1CurrentLng;
        ui.$Step1Bounds;
        ui.$Step1Coordinates = {};
        ui.$Fired = true;
        ui.$SelectedHospitalName;

        //Step2 - Profile 
        ui.$Step2ContinueBtn = $('#ActivateAcctProfileContinueBtn');
        ui.$Step2Email = $('#ActivateAccountEmail');
        ui.$Step2FirstName = $('#ActivateAccountFName');
        ui.$Step2LastName = $('#ActivateAccountLName');
        ui.$Step2PhoneNum = $('#ActivateAccountPhoneNum');
        ui.$EmailValid = false;
        ui.$FirstNameValid = false;
        ui.$LastNameValid = false;
        ui.$PhoneNumValid = false;

        //Step3 - Verify Your Account
        ui.$Step3ContinueBtn = $('#VerifyYourAcctContinueBtn');
        ui.$Step3StreetNum = $('#ActivateAccountStreetNum');
        ui.$Step3Street = $('#ActivateAccountStreet');
        ui.$Step3PetNameList = $('.pet-name-list');
        ui.$Step3VerifyAcctEmptyResponse = $('.verifyacct-errormsg.empty-response')
        ui.$Step3GetChallengeData = {};

        //Step4 - Set Password
        ui.$Step4ContinueBtn = $('#ActivateAcctPasswordContinueBtn');
        ui.$Step4ErrorMsg = $('#ActivateAccountErrorMsg');
        ui.$PasswordInput = $('.account-password-input');
        ui.$PasswordEyeIcon = $('.password-eye-icon');
        ui.$Step4APIFired = true;

        //Loader Spinner
        ui.$Step1LoaderSpinner = $('.account-loader-spinner.step1');

        //Back Btn
        ui.$BackBtn = $('.account-setup__back-btn');

        //Other
        ui.$InputEl = $('input');
        ui.$RequestVerificationToken = $('input[name="__RequestVerificationToken"]').val();
        ui.$DataSourceId = $('input[name="DatasourceId"]').val();
        ui.isCanada = $('[data-iscanada]').attr('data-iscanada');

        //Global Variables required for step4
        ui.$HospitalId;
        ui.$ClientId;
        ui.$FirstName;
        ui.$LastName;
        ui.$Email;
        ui.$Phone;
        ui.$Password;
    }

    function bindEvents() {
        ui.$Step1ContinueBtn.on('click', validateFahStep1);
        ui.$Step2ContinueBtn.on('click', validateProfileStep2);
        ui.$Step3ContinueBtn.on('click', validateVerifyAcctStep3);
        ui.$Step4ContinueBtn.on('click', validateSetPasswordStep4);

        //Other
        ui.$Step1ZipCode.on('keyup', initZipcode);
        ui.$Step2Email.on('blur', validateEmail);
        ui.$Step2PhoneNum.on('keydown', detectKeydown);
        ui.$Step3Street.on('keyup paste', hideStreetErrMsg);
        ui.$PasswordEyeIcon.on('click', togglePassword);
        ui.$PasswordInput.on('focus', showTooltipModal);
        ui.$PasswordInput.on('blur', hideTooltipModal);
        ui.$PasswordInput.on('keyup paste', validatePassword);
        ui.$BackBtn.on('click', backBtnClick);
        ui.$InputEl.on('keyup paste', hideErrorMessages);
    }

    function init() {
        if ($('.activate-account-setup').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
    }

    function hideErrorMessages(e) {
        const el = $(e.currentTarget);
        el.removeClass('error');
        el.closest('.form-label-group').find('.input-error-text').hide();
    }

    /*********************** STEP 1: Find Your Hospital *************************/
    function initZipcode() {
        let zipCodeValue = ui.$Step1ZipCode.val();
        let maxCharacters = 5;
        let canadaZipCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

        ui.$Step1ZipCode.removeClass('error');
        ui.$Step1ZipCode.parent().find('.input-error-text').hide();
        ui.$Step1AcctFahErrMsg.hide();

        //Need to check if IsCanada = true
        if (isCanada) {
            let isValidCanadaZipCode = canadaZipCodeRegex.test(zipCodeValue);

            if (isValidCanadaZipCode) {
                ui.$Fired = false;
                ui.$Step1AcctFahList.hide();
                ui.$Step1AcctFahList.empty();
                initGeocoder(zipCodeValue);
            } else {
                ui.$Step1AcctFahContainer.hide();
                ui.$Step1AcctFahErrMsg.hide();
                ui.$Step1AcctFahList.empty();
            }

        } else {
            //Need to limit characters to 5
            if (zipCodeValue.length >= maxCharacters) { 
                ui.$Step1ZipCode.val(zipCodeValue.substr(0, maxCharacters));
            }

            if (zipCodeValue.length < maxCharacters) {
                ui.$Step1AcctFahContainer.hide();
                ui.$Step1AcctFahErrMsg.hide();
                ui.$Step1AcctFahList.empty();
            }

            if (zipCodeValue.length === maxCharacters && ui.$Fired) {
                ui.$Fired = false;
                ui.$Step1AcctFahList.hide();
                ui.$Step1AcctFahList.empty();
                initGeocoder(zipCodeValue);
            }
        }
    }

    function initGeocoder(zipCodeValue) {
        let zipCode = zipCodeValue;

        ui.$Step1AcctFahErrMsg.hide();
        ui.$Step1AcctFahContainer.css('border', 'none').show();
        ui.$Step1LoaderSpinner.show();

        //****** GEOCODER *******
        ui.$Step1Geocoder = new google.maps.Geocoder();
        ui.$Step1Geocoder.geocode({
            'address': zipCode
        }, function (results, status) {
            if (status == 'OK') {
                ui.$Step1CurrentLat = results[0].geometry.location.lat();
                ui.$Step1CurrentLng = results[0].geometry.location.lng();
                ui.$Step1Coordinates = getSearchBounds();
                initHospitals(ui.$Step1Coordinates);
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
                ui.$Step1AcctFahContainer.hide();
                ui.$Step1LoaderSpinner.hide();
                ui.$Step1AcctFahInvalidZipCodeErrMsg.show();
                ui.$Fired = true;
            }
        });
    }

    function getSearchBounds() {
        ui.$Step1Bounds = getBounds(ui.$Step1CurrentLat, ui.$Step1CurrentLng, ui.$Step1Radius);
        let coordinatesResult = calcMinMaxLatLng(ui.$Step1Bounds);

        return coordinatesResult;
    }

    function getBounds(lat, lng, radius) {
        let ConvertedRadius = radius * 1609.34;

        // add to canada site
         if(ui.isCanada === 'true'){
             ConvertedRadius = radius * 1000;
         }

        var circleData = {
            center: {
                lat,
                lng
            },
            radius: ConvertedRadius
        };

        if (window['google']) {
            return new window['google'].maps.Circle(circleData).getBounds();
        }
    }

    function calcMinMaxLatLng(bounds) {
        var obj = {
            minLat: bounds.getNorthEast().lat(),
            maxLat: bounds.getSouthWest().lat(),
            minLng: bounds.getNorthEast().lng(),
            maxLng: bounds.getSouthWest().lng()
        }
        return obj;
    }

    function initHospitals(coordinates) {
        let payload = {
            MinLatitude: coordinates.minLat,
            MaxLatitude: coordinates.maxLat,
            MinLongitude: coordinates.minLng,
            MaxLongitude: coordinates.maxLng,
        }

        //API CALL
        getHospitals(payload);
    }

    async function getHospitals(payload) {
        ui.$Fired = true;

        const url = '/myvca-api/get-hospitals';
        let api = new ApiService(url);
        let query = {
            minLat: payload.MinLatitude,
            maxLat: payload.MaxLatitude,
            minLong: payload.MinLongitude,
            maxLong: payload.MaxLongitude
        }
        const { data, success, error } = await api.query(query);

        if (!success || (error !== null && error !== '')) {
                ui.$Step1AcctFahContainer.hide();
                ui.$Step1LoaderSpinner.hide();
                ui.$Step1AcctFahAPIErrMsg.html(error);
                ui.$Step1AcctFahAPIErrMsg.show();
        } else { 
            ui.$Step1LoaderSpinner.hide();
            let results = data;

            if (results == null || results == undefined) {
                ui.$Step1AcctFahContainer.hide();
                ui.$Step1AcctFahEmptyResponse.show();
            } else {
                ui.$Step1AcctFahContainer.css('border', '1px solid #979797').show();
                createHospitalItems(results);
            }
        }
    }

    function createHospitalItems(json) {
        let data = json;

        for (let i = 0; i < data.length; i++) {
            let hospital = $(`
                <div class="account-fah__radio-item">
                    <input id="ChooseHospital-${i}" class="acct-choose-hospital" name="hospital-radio-group" type="radio" value="${data[i].HospitalId}" data-name="${data[i].DisplayName}">
                    <label for="ChooseHospital-${i}" class="control-radio__label">${data[i].DisplayName}</label>
                </div>
            `);
            ui.$Step1AcctFahList.append(hospital);
        }
        validateHospitalSelected();
        ui.$Step1AcctFahList.show();
    }

    function validateHospitalSelected() {
        $('.acct-choose-hospital').on('click', () => {
            let radio = $("input[type=radio][name=hospital-radio-group]").filter(":checked")[0];

            if (radio) {
                ui.$Step1AcctFahErrMsg.hide();
            }
        });
    }

    function validateFahStep1() {
        let zipCodeVal = ui.$Step1ZipCode.val();
        let radio = $("input[type=radio][name=hospital-radio-group]").filter(":checked")[0];
        let hospitalSelected = false;
        let canadaZipCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

        ui.$Step1ZipCode.parent().find('.error-msg').hide();
        
        //validate if zip code input field is empty
        if (zipCodeVal.trim() == '') {
            ui.$Step1ZipCode.addClass('error');
            ui.$Step1ZipCode.parent().find('.error-msg.required').show();
            ui.$Step1ZipCode.parent().find('.input-error-text').show();
        } else {
            ui.$Step1ZipCode.removeClass('error');
            ui.$Step1ZipCode.parent().find('.input-error-text').hide();
        }

        //Validate if user types an invalid zipcode
        if (isCanada) {
            let isValidCanadaZipCode = canadaZipCodeRegex.test(zipCodeVal);
            ui.$Step1ZipCode.parent().find('.error-msg').hide();
            if (isValidCanadaZipCode) {
                ui.$Step1ZipCode.removeClass('error');
                ui.$Step1ZipCode.parent().find('.input-error-text').hide();
            } else {
                ui.$Step1ZipCode.addClass('error');
                ui.$Step1ZipCode.parent().find('.error-msg.invalid').show();
                ui.$Step1ZipCode.parent().find('.input-error-text').show();
            }

        } else {
            if (zipCodeVal.trim() !== '') {
                if (zipCodeVal.length < 5) {
                    ui.$Step1ZipCode.addClass('error');
                    ui.$Step1ZipCode.parent().find('.error-msg.invalid').show();
                    ui.$Step1ZipCode.parent().find('.input-error-text').show();
                } else {
                    ui.$Step1ZipCode.removeClass('error');
                    ui.$Step1ZipCode.parent().find('.input-error-text').hide();
                }
            }
        }

        //Validate if radio input has been selected
        if (radio) {
            hospitalSelected = true;
            //Assign HospitalId - global variable (step 4)
            ui.$HospitalId = $(radio).val();
            //Assign Hospital Name - global variable
            ui.$SelectedHospitalName = $(radio).data('name');
        } else if (!radio && ui.$Step1AcctFahList.children().length > 0) {
            ui.$Step1AcctFahSelectHospitalErrMsg.show();
        }

        //Check if hospitalSelected is true --> move on to STEP 2
        if (hospitalSelected) {
            let targetValue = ui.$Step1ContinueBtn.data('target');

            ui.$sections.hide();
            updateProgressBar(targetValue);
            $('.acct-hospital-name').html(ui.$SelectedHospitalName);
            ui.$ProfileStep.show();
        }
    }
    /*********************** End of STEP 1: Find Your Hospital *************************/

    /*********************** STEP 2: Profile *************************/
    function detectKeydown(e) {
        if (e.which === 38 || e.which === 40) {
            e.preventDefault();
        }
    }

    function validateEmail() {
        let emailValue = ui.$Step2Email.val();
        let emailRegex = /\S+@\S+\.\S+/;
        let validateEmail = emailRegex.test(emailValue);
        ui.$Step2Email.attr('value', emailValue);
        ui.$Step2Email.parent().find('.error-msg').hide();


        if (emailValue.trim() == '') {
            ui.$Step2Email.addClass('error');
            ui.$Step2Email.parent().find('.error-msg.required').show();
            ui.$Step2Email.parent().find('.input-error-text').show();
        } else {
            if (validateEmail) {
                ui.$Step2Email.removeClass('error');
                ui.$Step2Email.parent().find('.input-error-text').hide();
                validateEmailAPI(emailValue);
            } else {
                ui.$Step2Email.addClass('error');
                ui.$Step2Email.parent().find('.error-msg.invalid').show();
                ui.$Step2Email.parent().find('.input-error-text').show();
            }
        }
    }

    async function validateEmailAPI(email) {

        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');

        let payload = {
            email: email,
            '__RequestVerificationToken': ui.$RequestVerificationToken
        }

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }

        const url = `/myvca-api/check-if-email-is-used`;
        let api = new ApiService(url);
        const { data, success, error } = await api.post(searchParams(payload), axiosConfig);


        if (!success || (error !== null && error !== '')) {
            alert(error);
        } else { 
            let emailExists = data;

            if (emailExists) {
                ui.$Step2Email.addClass('error');
                ui.$Step2Email.parent().find('.error-msg.email-exists').show();
                ui.$Step2Email.parent().find('.input-error-text').show();
                ui.$Step2ContinueBtn.attr('disabled', 'disabled');
            } else {
                ui.$EmailValid = true;
                ui.$Email = email;
                ui.$Step2Email.removeClass('error');
                ui.$Step2Email.parent().find('.input-error-text').hide();
                ui.$Step2ContinueBtn.removeAttr('disabled');
            }
        }
    }

    function validateProfileStep2() {
        let firstName = ui.$Step2FirstName.val();
        let lastName = ui.$Step2LastName.val();
        let phoneNum = ui.$Step2PhoneNum.val();

        ui.$Step2FirstName.attr('value', firstName);
        ui.$Step2LastName.attr('value', lastName);
        ui.$Step2PhoneNum.attr('value', phoneNum);

        //Validate Email
        validateEmail();

        //Validate first name and last name
        if (firstName.trim() == '') {
            ui.$Step2FirstName.addClass('error');
            ui.$Step2FirstName.parent().find('.input-error-text').show();
            ui.$FirstNameValid = false;
        } else {
            ui.$Step2FirstName.removeClass('error');
            ui.$Step2FirstName.parent().find('.input-error-text').hide();
            ui.$FirstNameValid = true;
            ui.$FirstName = firstName;
        }

        if (lastName.trim() == '') {
            ui.$Step2LastName.addClass('error');
            ui.$Step2LastName.parent().find('.input-error-text').show();
            ui.$LastNameValid = false;
        } else {
            ui.$Step2LastName.removeClass('error');
            ui.$Step2LastName.parent().find('.input-error-text').hide();
            ui.$LastNameValid = true;
            ui.$LastName = lastName;
        }

        //Validate Phone Number
        if (phoneNum == '') {
            ui.$Step2PhoneNum.parent().find('.error-msg').hide();
            ui.$Step2PhoneNum.addClass('error');
            ui.$Step2PhoneNum.parent().find('.error-msg.required').show();
            ui.$Step2PhoneNum.parent().find('.input-error-text').show();
        } else {
            ui.$Step2PhoneNum.parent().find('.error-msg').hide();

            if (phoneNum.length == 10) {
                ui.$Step2PhoneNum.removeClass('error');
                ui.$Step2PhoneNum.parent().find('.input-error-text').hide();
                ui.$PhoneNumValid = true;
                ui.$Phone = phoneNum;
            } else {
                ui.$Step2PhoneNum.addClass('error');
                ui.$Step2PhoneNum.parent().find('.error-msg.invalid').show();
                ui.$Step2PhoneNum.parent().find('.input-error-text').show();
                ui.$PhoneNumValid = false;
            }
        }        
        

        //If all input fields are valid --> Move on to STEP 3
        if (ui.$EmailValid && ui.$FirstNameValid && ui.$LastNameValid && ui.$PhoneNumValid) {
            getChallengeData(ui.$HospitalId,ui.$FirstName,ui.$LastName,ui.$Email,ui.$Phone);
        } 

    }

    async function getChallengeData(hospitalId,firstName,lastName,email,phone) {

        const url = `/myvca-api/get-challenge`;
        let api = new ApiService(url);
        let query = { hospitalId, firstName, lastName, email, phone }
        const { data, success, error } = await api.query(query);

        if (!success || (error !== null && error !== '')) {
            alert(error);
        } else {
            let results = data;

            if (results == null 
                || results.ChallengeResponse == null
                || results.ChallengeResponse.id == null
                || results.ChallengeResponse.id == ''
                || results.ChallengeResponse.addressChallenge == null
                || results.ChallengeResponse.addressChallenge.id == null
                || results.ChallengeResponse.addressChallenge.id == ''
                || results.ChallengeResponse.addressChallenge.postGap == ''
                || results.ChallengeResponse.addressChallenge.postGap == null
                || results.ChallengeResponse.petNameChallenge == null
                || results.ChallengeResponse.petNameChallenge.id == null
                || results.ChallengeResponse.petNameChallenge.id == ''
                || results.ChallengeResponse.petNameChallenge.choices == null
                || results.ChallengeResponse.petNameChallenge.choices.length == 0
                || results.ClientId == null
                || results.ClientId == 0) {
                $('.step2-err-msg').show();
            } else { //ALL SUCCESS

                $('.step2-err-msg').hide();
                let targetValue = ui.$Step2ContinueBtn.data('target');

                initVerifyAcctStepData(results);
                ui.$sections.hide();
                updateProgressBar(targetValue);
                ui.$VerifyYourAccountStep.show();
            }
        }
    }
    /*********************** End of STEP 2: Profile *************************/


    /*********************** STEP 3: Verify Your Account *************************/
    function hideStreetErrMsg() {
        const el = $(e.currentTarget);
        el.removeClass('error');
        el.parent('.verify-acct-step__street-address').find('.verify-acct-step__streetnum-errormsg').hide();
    }

    function initVerifyAcctStepData(data) {
        ui.$Step3GetChallengeData = data;

        //1. Assign gap length and street name to $('#ActivateAccountStreet')
        let n = data.ChallengeResponse.addressChallenge.gapLength;
        let spaces = new Array(++n).join('*');
        let address = data.ChallengeResponse.addressChallenge.preGap + spaces + data.ChallengeResponse.addressChallenge.postGap;
        ui.$Step3Street.html(address);

        //3. Create individual pet name radio option and append to list
        let petNamesResults = data.ChallengeResponse.petNameChallenge.choices;

        ui.$Step3PetNameList.empty();
        for (let i = 0; i < petNamesResults.length; i++) {
            let petNameItem = $(`
                <div class="verify-acct-step__radio-item">
                    <input id="ChoosePetName-${i}" class="acct-choose-petname" name="petname-radio-group" type="radio" data-name="${petNamesResults[i]}">
                    <label for="ChoosePetName-${i}" class="control-radio__label">${petNamesResults[i]}</label>
                </div>
            `);
            ui.$Step3PetNameList.append(petNameItem);
        }
        validatePetNameSelected();
    }
    
    function validatePetNameSelected() {
        $('.acct-choose-petname').on('click', () => {
            let radio = $("input[type=radio][name=petname-radio-group]").filter(":checked")[0];

            if (radio) {
                $('.pet-name-errormsg').hide();
            }
        });
    }

    function validateVerifyAcctStep3() {
        let hospitalId = ui.$HospitalId;
        let clientId = ui.$Step3GetChallengeData.ClientId;
        let challengeSetId = ui.$Step3GetChallengeData.ChallengeResponse.id;
        let addressChallengeId = ui.$Step3GetChallengeData.ChallengeResponse.addressChallenge.id;
        let addressChallengeAnswer = ui.$Step3StreetNum.val(); 
        let petNameChallengeId = ui.$Step3GetChallengeData.ChallengeResponse.petNameChallenge.id;
        let petNameChallengeAnswer = '';

        let streetNumErrMsgWrapper = $('.verify-acct-step__streetnum-errormsg');
        let streetNumValid = false;
        let petNameSelected = false;

        ui.$Step3StreetNum.attr('value', addressChallengeAnswer);
        ui.$ClientId = clientId;

        
        //Validate if street number input has a value
        if (addressChallengeAnswer.trim() == '') {
            streetNumValid = false;
            ui.$Step3StreetNum.addClass('error');
            streetNumErrMsgWrapper.show();
        } else {
            streetNumValid = true;
            ui.$Step3StreetNum.removeClass('error');
            streetNumErrMsgWrapper.hide();
        }

        //Validate if a pet name has been selected
        let radio = $("input[type=radio][name=petname-radio-group]").filter(":checked")[0];

        if (radio) {
            petNameSelected = true;
            petNameChallengeAnswer = $(radio).data('name');
        } else {
            petNameSelected = false;
            $('.pet-name-errormsg').show();
        }


        //Validate all required fields
        if (streetNumValid && petNameSelected) {
            confirmChallenge(hospitalId,clientId,challengeSetId,addressChallengeId,addressChallengeAnswer,petNameChallengeId,petNameChallengeAnswer);
        } 

    }

    async function confirmChallenge(hospitalId,clientId,challengeSetId,addressChallengeId,addressChallengeAnswer,petNameChallengeId,petNameChallengeAnswer) {
        
        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');

        let payload = {
            hospitalId: hospitalId,
            clientId: clientId,
            challengeSetId: challengeSetId,
            addressChallengeId: addressChallengeId,
            addressChallengeAnswer: addressChallengeAnswer,
            petNameChallengeId: petNameChallengeId,
            petNameChallengeAnswer: petNameChallengeAnswer,
            '__RequestVerificationToken': ui.$RequestVerificationToken
        }
            
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }
        
        const url = `/myvca-api/confirm-challenge`;
        let api = new ApiService(url);
        const { data, success, error } = await api.post(searchParams(payload), axiosConfig);


        if (!success || (error !== null && error !== '')) {
            alert(error);
        } else { 
            let isValidUser = data;
            let errorMsgEl = $('#ValidUserFalse');
            
            if (isValidUser) {
                errorMsgEl.hide();
                ui.$Step3ContinueBtn.removeAttr('disabled');

                let targetValue = ui.$Step3ContinueBtn.data('target');
                ui.$sections.hide();
                updateProgressBar(targetValue);
                ui.$SetPasswordStep.show();

            } else {
                errorMsgEl.show();
                ui.$Step3ContinueBtn.attr('disabled', 'disabled');
            }
        }
    }
    /*********************** End of STEP 3: Verify Your Account *************************/


    /*********************** STEP 4: Set Password *************************/
    function togglePassword() {
        // toggle the type attribute
        let passwordInput = $(this).closest('.form-label-group').find('.account-password-input');
        const type = $(passwordInput).attr('type') === 'password' ? 'text' : 'password';
        $(passwordInput).attr('type', type);
        // toggle the eye slash icon
        $(this).toggleClass('fa-eye-slash');
    }

    function validatePassword() {
        let passwordInput = this;
        let inputType = $(passwordInput).data('type');

        if (inputType == 'general-password'){
            let generalPwValue = $(passwordInput).val();
            $(passwordInput).attr('value', generalPwValue);
            generalPwFinalValue = generalPwValue;

            // Have one number
            const oneNumRegex = /\d/;
            const hasOneNum = generalPwValue.match(oneNumRegex);
            let hasOneNumCircle = $('#PwOneNumber').siblings('.fill-circle');

            if (hasOneNum) {
                $(hasOneNumCircle).addClass('active');
                haveOneNumValid = true;
            } else {
                $(hasOneNumCircle).removeClass('active'); 
                haveOneNumValid = false;
            }

            //Have one uppercase character
            const oneUppercaseChar = /[A-Z]/;
            const hasOneUppercaseChar = generalPwValue.match(oneUppercaseChar);
            let hasOneUppercaseCircle = $('#PwOneUppercaseChar').siblings('.fill-circle');

            if (hasOneUppercaseChar) {
                $(hasOneUppercaseCircle).addClass('active');
                haveOneUppercaseValid = true;
            } else {
                $(hasOneUppercaseCircle).removeClass('active');
                haveOneUppercaseValid = false;
            }

            //Have one lowercase character
            const oneLowercaseChar = /[a-z]/;
            const hasOneLowercaseChar = generalPwValue.match(oneLowercaseChar);
            let hasOneLowercaseCircle = $('#PwOneLowercaseChar').siblings('.fill-circle');

            if (hasOneLowercaseChar) {
                $(hasOneLowercaseCircle).addClass('active');
                haveOneLowercaseValid = true;
            } else {
                $(hasOneLowercaseCircle).removeClass('active');
                haveOneLowercaseValid = false;
            }

            //Have one special chracter
            const oneSpecialChar = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            const hasOneSpecialChar = generalPwValue.match(oneSpecialChar);
            let hasOneSpecialCircle = $('#PwOneSpecialChar').siblings('.fill-circle');

            if (hasOneSpecialChar) {
                $(hasOneSpecialCircle).addClass('active');
                haveOneSpecialCharValid = true;
            } else {
                $(hasOneSpecialCircle).removeClass('active');
                haveOneSpecialCharValid = false;
            }

            //Have 8 characters min
            const min8Char = /^(?=.*\d).{8,}$/;
            const hasMin8Char = generalPwValue.match(min8Char);
            let hasMin8CharCircle = $('#PwMin8Char').siblings('.fill-circle');

            if (hasMin8Char) {
                $(hasMin8CharCircle).addClass('active');
                have8MinCharValid = true;
            } else {
                $(hasMin8CharCircle).removeClass('active');
                have8MinCharValid = false;
            }

            //Use case to see if passwords match
            let pwMatchCircle = $('#PasswordsMatch').siblings('.fill-circle');
            if (confirmPwFinalValue.trim() !== '' && generalPwFinalValue.trim() !== '' && confirmPwFinalValue == generalPwFinalValue) {
                $(pwMatchCircle).addClass('active');

                if (haveOneNumValid && haveOneUppercaseValid && haveOneLowercaseValid && haveOneSpecialCharValid && have8MinCharValid) {
                    ui.$Password = generalPwValue;
                    ui.$Step4ContinueBtn.removeAttr('disabled');
                }
            } else {
                $(pwMatchCircle).removeClass('active');
                ui.$Step4ContinueBtn.attr('disabled', 'disabled');
            }
        } 

        if (inputType == 'confirm-password'){

            let confirmPwValue = $(passwordInput).val();
            let passwordsMatchCircle = $('#PasswordsMatch').siblings('.fill-circle');
            $(passwordInput).attr('value', confirmPwValue);
            confirmPwFinalValue = confirmPwValue;

            if (confirmPwFinalValue.trim() !== '' && generalPwFinalValue.trim() !== '' && confirmPwFinalValue == generalPwFinalValue) {
                $(passwordsMatchCircle).addClass('active');

                if (haveOneNumValid && haveOneUppercaseValid && haveOneLowercaseValid && haveOneSpecialCharValid && have8MinCharValid) {
                    ui.$Password = confirmPwValue;
                    ui.$Step4ContinueBtn.removeAttr('disabled');
                }
            } else {
                $(passwordsMatchCircle).removeClass('active');
                ui.$Step4ContinueBtn.attr('disabled', 'disabled');
            }
        }
        
    }

    function showTooltipModal(e) {
        let pwInputEl = $(e.currentTarget);
        pwInputEl.closest('.form-label-group').find('.password-tooltip').show(); 
    }

    function hideTooltipModal(e) {
        let pwInputEl = $(e.currentTarget);
        pwInputEl.closest('.form-label-group').find('.password-tooltip').hide(); 
    }

    function validateSetPasswordStep4() {
        ui.$Step4APIFired = true;

        let payload = {
            HospitalId: ui.$HospitalId,
            ClientId: ui.$ClientId,
            FirstName: ui.$FirstName,
            LastName: ui.$LastName,
            Email: ui.$Email,
            Phone: ui.$Phone,
            Password: ui.$Password,
            DatasourceId: ui.$DataSourceId,
            '__RequestVerificationToken': ui.$RequestVerificationToken
        }
        ui.$Step4ErrorMsg.hide();

        if (ui.$Step4APIFired) {
            ui.$Step4APIFired = false;
            signUpUserAccount(payload);
        }
    }

    async function signUpUserAccount(payload) {
        ui.$Step4APIFired = true;

        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
            
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }

        const url = '/myvca-api/submit-signup';
        let api = new ApiService(url);
        const { data, success, error } = await api.post(searchParams(payload), axiosConfig);

        if (success && data !== null && data !== '' && data !== undefined) {
            window.VCA.AccountDatalayer.dataLayerActivateAcctSuccess();
            location.href = data;
        } else {
            ui.$Step4ErrorMsg.html(error);
            ui.$Step4ErrorMsg.show();
        }
    }
    /*********************** STEP 4: Set Password *************************/

    /** OTHER **/
    function backBtnClick() {
        let backBtn = this;
        let targetValue = $(backBtn).data('target');

        ui.$sections.hide();
        updateProgressBar(targetValue);
        $('section[data-step="' + targetValue + '"').show();
    }

    function updateProgressBar(targetValue) {
        let progressValue = $('section[data-step="' + targetValue + '"').data('progress');
        $('.progress-bar').css('width', progressValue+'%').attr('aria-valuenow', progressValue);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ActivateAccountSetUp.init();
});
